import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/images/logo.png';
import './Navbar.css';

const NAV_LINKS = [
  { label: 'Home',         path: '/' },
  { label: 'About',        path: '/about' },
  {
    label: 'Treatments',   path: '/treatments',
    sub: [
      { label: 'Pain Medicine',     path: '/treatments/pain-medicine' },
      { label: 'Sports Ortho',      path: '/treatments/orthopaedics'  },
      { label: 'Physiotherapy',     path: '/treatments/physiotherapy' },
    ],
  },
  { label: 'Conditions',   path: '/conditions'   },
  { label: 'Doctors',      path: '/doctors'       },
  { label: 'Testimonials', path: '/testimonials'  },
  { label: 'Contact',      path: '/contact'       },
];

export default function Navbar() {
  const [scrolled,     setScrolled]     = useState(false);
  const [mobileOpen,   setMobileOpen]   = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const location = useLocation();
  const isHome   = location.pathname === '/';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setOpenDropdown(null);
  }, [location]);

  const navClass = `navbar ${scrolled || !isHome ? 'scrolled' : 'transparent'}`;

  return (
    <header className={navClass}>
      <div className="container nav-inner">

        {/* ── Logo ── */}
        <Link to="/" className="logo">
          <div className="logo-icon">
            <img src={logo} alt="TheOrthomed Logo" className="logo-img" />
          </div>
          {/* <div className="logo-text">
            <span className="logo-name">THE ORTHOMED</span>
            <span className="logo-sub">Sports Ortho + Regenerative Medicine</span>
          </div> */}
        </Link>

        {/* ── Desktop nav ── */}
        <nav className="desktop-nav">
          {NAV_LINKS.map(link => (
            <div
              key={link.label}
              className="nav-item"
              onMouseEnter={() => link.sub && setOpenDropdown(link.label)}
              onMouseLeave={() => setOpenDropdown(null)}
            >
              <Link
                to={link.path}
                className={`nav-link ${
                  location.pathname === link.path ||
                  location.pathname.startsWith(link.path + '/')
                    ? 'active' : ''
                }`}
              >
                {link.label}
                {link.sub && (
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" style={{ marginLeft: 4 }}>
                    <path d="M3 5l3 3 3-3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                  </svg>
                )}
              </Link>

              {link.sub && openDropdown === link.label && (
                <div className="dropdown">
                  {link.sub.map(sub => (
                    <Link key={sub.path} to={sub.path} className="dropdown-item">
                      {sub.label}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          ))}
        </nav>

        <Link to="/contact" className="btn-primary nav-cta">Book Appointment</Link>

        {/* ── Hamburger ── */}
        <button
          className={`hamburger ${mobileOpen ? 'open' : ''}`}
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          <span/><span/><span/>
        </button>
      </div>

      {/* ── Mobile menu ── */}
      {mobileOpen && (
        <div className="mobile-menu">
          {NAV_LINKS.map(link => (
            <div key={link.label}>
              <Link to={link.path} className="mobile-link">{link.label}</Link>
              {link.sub && link.sub.map(sub => (
                <Link key={sub.path} to={sub.path} className="mobile-link mobile-sub">
                  {sub.label}
                </Link>
              ))}
            </div>
          ))}
          <Link
            to="/contact"
            className="btn-primary"
            style={{ margin: '16px', display: 'block', textAlign: 'center' }}
          >
            Book Appointment
          </Link>
        </div>
      )}
    </header>
  );
}
